import { TFunction } from 'i18next';
import {
  ImpactLevel,
  MaterialityTypes,
  MaturityLevel,
  PriorityLevel,
  ProbabilityLevel,
  QualityLevel,
} from '@/graphql/generated';

export function getMaturityLabel(
  t: TFunction,
  maturity: MaturityLevel | null | undefined,
): string {
  switch (maturity) {
    case MaturityLevel.None:
      return t('diagnostic.maturity.none');
    case MaturityLevel.Low:
      return t('diagnostic.maturity.low');
    case MaturityLevel.Medium:
      return t('diagnostic.maturity.medium');
    case MaturityLevel.High:
      return t('diagnostic.maturity.high');
    case MaturityLevel.Computed:
      return t('diagnostic.maturity.computed');
    default:
      return t('diagnostic.maturity.default');
  }
}

export function getPriorityLabel(
  t: TFunction,
  priority: PriorityLevel | null,
): string {
  switch (priority) {
    case PriorityLevel.None:
      return t('diagnostic.priority.none');
    case PriorityLevel.Low:
      return t('diagnostic.priority.low');
    case PriorityLevel.Medium:
      return t('diagnostic.priority.medium');
    case PriorityLevel.High:
      return t('diagnostic.priority.high');
    case PriorityLevel.Computed:
      return t('diagnostic.priority.computed');
    default:
      return t('diagnostic.priority.default');
  }
}

export function getImpactLabel(
  t: TFunction,
  priority: ImpactLevel | null,
): string {
  switch (priority) {
    case ImpactLevel.None:
      return t('diagnostic.impact.none');
    case ImpactLevel.Low:
      return t('diagnostic.impact.low');
    case ImpactLevel.Medium:
      return t('diagnostic.impact.medium');
    case ImpactLevel.High:
      return t('diagnostic.impact.high');
    case ImpactLevel.Computed:
      return t('diagnostic.impact.computed');
    default:
      return t('diagnostic.impact.default');
  }
}

export function getQualityLabel(
  t: TFunction,
  quality: QualityLevel | null,
  materialityType: MaterialityTypes,
): string {
  const keyPrefix =
    materialityType === MaterialityTypes.Financial
      ? 'quality.financial'
      : 'quality.other';
  switch (quality) {
    case QualityLevel.Negative:
      return t(`${keyPrefix}.negative`);
    case QualityLevel.Positive:
      return t(`${keyPrefix}.positive`);
    case QualityLevel.Neutral:
    default:
      return t(`${keyPrefix}.neutral`);
  }
}

export function getProbabilityLabel(
  t: TFunction,
  probability: ProbabilityLevel | null,
): string {
  switch (probability) {
    case ProbabilityLevel.Low:
      return t('diagnostic.probability.low');
    case ProbabilityLevel.Medium:
      return t('diagnostic.probability.medium');
    case ProbabilityLevel.High:
      return t('diagnostic.probability.high');
    case ProbabilityLevel.Certain:
      return t('diagnostic.probability.certain');
    default:
      return t('diagnostic.probability.default');
  }
}
